import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import Hamburger from '@/components/Hamburger';
import { utilCookies } from '@/util/cookies';
import { getAvatar } from '@/util/util';
import { companyLogin } from '@/api/login'; // 获取个人信息
import { getPendingTaskCount } from '@/api/payroll';
var icon_company = require('@/assets/img/icon_company.png');
export default {
  props: {
    task: {
      type: Object
    }
  },
  components: {
    Hamburger: Hamburger
  },
  data: function data() {
    return {
      icon_company: icon_company,
      activeIndex: '',
      language: utilCookies.getLanguage(),
      baseInfo: {},
      companyList: [],
      visible: false,
      count: 0,
      add: 0,
      clearTime: null,
      data: {
        logout: ''
      },
      companyName: '',
      companyLength: 0
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['sidebar', 'name', 'staffId', 'staffName', 'staffDepartment', 'contractCount', 'avatar'])), mapState({
    company_info: function company_info(state) {
      return state.user.company_info;
    }
  })), {}, {
    isSa: function isSa() {
      return this.company_info && this.company_info.is_sa;
    },
    showTipExpire: function showTipExpire() {
      if (this.company_info.left_days <= 7 && this.isSa) return true;
      return false;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    },
    langArr: function langArr() {
      return this.$store.state.settings.langArr;
    },
    curLang: {
      get: function get() {
        return this.$store.state.settings.curLang;
      },
      set: function set(val) {
        this.$store.commit('settings/updateCurLang', val);
      }
    },
    // 计算宽度
    navWidth: function navWidth() {
      return this.isCollapse ? 48 : 216;
    },
    wrapWidth: function wrapWidth() {
      return "calc(100% - ".concat(this.navWidth, "px)");
    }
  }),
  created: function created() {
    this.pendingTaskCount(); // 任务count
    try {
      this.baseInfo = this.$s.get('userInfo');
      this.companyList = this.$s.get('companyList');
      this.companyLength = (this.$s.get('companyList') || []).length;
    } catch (error) {}
  },
  methods: {
    getAvatar: getAvatar,
    clickItem: function clickItem(name, type) {
      this.$router.push({
        name: name,
        query: {
          type: type
        }
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    pendingTaskCount: function pendingTaskCount() {
      if (process.env.NODE_ENV !== 'development') {
        // eslint-disable-next-line no-inner-declarations
        var timerFn = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var res;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  this_.add++;
                  _context.next = 3;
                  return getPendingTaskCount();
                case 3:
                  res = _context.sent;
                  if (res && res.code === 1) {
                    // 第二次请求才提示任务完成
                    if (this_.add > 1 && this_.count > res.data.count) {
                      this_.$message({
                        type: 'success',
                        message: this_.$t('payroll_salary_29')
                      });
                    }
                    this_.count = res.data.count;
                  }
                  this_.clearTime = setTimeout(timerFn, 5000);
                case 6:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function timerFn() {
            return _ref.apply(this, arguments);
          };
        }();
        // 任务count
        var this_ = this;
        timerFn();
      }
    },
    logout: function logout() {
      this.$util.messageBox(this.$t('301'), 'warning', function () {
        utilCookies.removeToken();
        utilCookies.removeCompanyToken();
        window.location.reload();
      }, function () {});
    },
    // 公司登录
    handleCompanyLogin: function handleCompanyLogin(item) {
      var _this = this;
      if (item.c_id === this.company_info.c_id) return;
      this.loading = true;
      var hash = window.location.hash;
      var href = window.location.href;
      var url = href.replace(hash, '#/dashboard');
      localStorage.removeItem('accessRecord');
      companyLogin({
        c_id: item.c_id
      }).then(function (res) {
        _this.$ga.event('FHRSelectCompany', 'click', 'ScanQR', 18); // 登录公司埋点
        var data = res.data;
        utilCookies.setCompanyToken(data.token);
        _this.$s.set('currentCompany', data.info);
        _this.$s.set('userInfo', data.info);
        window.location.href = url;
        window.location.reload();
      }).finally(function () {
        _this.loading = false;
      });
    },
    loginCompany: function loginCompany() {
      this.$router.push({
        path: '/login/create-company'
      });
    },
    onDownload: function onDownload() {
      // 异步下载列表
      this.$emit('onDownload');
    },
    changeLanguage: function changeLanguage(lang) {
      this.curLang = lang;
      localStorage.setItem('language', lang.key);
    },
    // 模糊搜索公司
    handleQueryCompanyByName: function handleQueryCompanyByName() {
      var _this2 = this;
      if (!this.companyName) {
        this.companyList = this.$s.get('companyList') || [];
        return;
      }
      var companyList = this.$s.get('companyList') || [];
      this.companyList = companyList.filter(function (item) {
        return item.name.includes(_this2.companyName);
      });
    }
  }
};